import React, { useEffect, useState } from 'react';
import { Box, Button, Group, Grid, Col } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import toast from 'react-hot-toast';
import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Add if missing
import { base64DecodeUnicode, base64EncodeUnicode } from '../../Utilities/OtherBasicFunction';

export default function SpecificationTab({ id, specification }) {

  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(''); 

  const form = useForm({
    initialValues: {
      propertyid: id || '',
    }
  });

  // ReactQuill toolbar configuration.
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      ['code'],
      [{ script: 'sub' }, { script: 'super' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
  };

  const formats = [
    'font',
    'size',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'script',
    'code',
    'list',
    'bullet',
    'indent',
    'align',
    'link',
    'image',
    'video',
    'clean',
  ];

  

  useEffect(() => {
    if (id) {
      const decrypted = specification
        ? base64DecodeUnicode(specification)
        : '';
      setContent(decrypted);
    }
  }, [id, user.compcode, specification]);

  const handleSubmit = async (values) => {

    if (!values.propertyid) {
      toast.error('Save property overview first...');
      return;
    }

    const payload = [
      {
        path: "/propertyspecification",
        op: "replace",
        value: base64EncodeUnicode(content),
      }
    ];

    setLoading(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/${ApiLinks.ProjectOverview_Patch}/${values.propertyid}`, payload
      );

      if (response.data.status) {
        toast.success('Specification Saved successfully');
      } else {
        toast.error(response.data.message || 'Failed to save');
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
      toast.error('Error submitting form');
    }
  };

  if (loading) return <LoaderOverlay />;

  return (
    <Box>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid gutter="md">
          <Col span={12} md={12}>
            <Grid gutter="md">
              <Col span={12}>
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  placeholder="Write property configuration..."
                  modules={modules}
                  formats={formats}
                  style={{ minHeight: '300px' }}
                />
              </Col>
              <Col span={12}>
                <Group position="right" mt="md">
                  <Button type="submit">Save</Button>
                  <Button variant="outline" onClick={() => navigate('/dashboard/floorplans')}>
                    Cancel
                  </Button>
                </Group>
              </Col>
            </Grid>
          </Col>
        </Grid>
      </form>
    </Box>
  );
}
